export default __webpack_public_path__ + "static/media/ic-quantity-0.56bfd674.svg";